<template>
  <div class="home">
    <TheHeader />
    <main>
      <HeroSection />
      <ProductSection />
      <FeatureSection />
      <PricingSection />
      <FaqSection />
    </main>
    <TheFooter />
  </div>
</template>

<script>
import HeroSection from "@/components/section/HeroSection.vue";
import ProductSection from "@/components/section/ProductSection.vue";
import FeatureSection from "@/components/section/FeatureSection.vue";
import PricingSection from "@/components/section/PricingSection.vue";
import FaqSection from "@/components/section/FaqSection.vue";
import TheHeader from "@/components/layout/Header.vue";
import TheFooter from "@/components/layout/Footer.vue";

export default {
  name: "NeolinkDjibView",
  components: {
    TheHeader,
    TheFooter,
    HeroSection,
    ProductSection,
    FeatureSection,
    PricingSection,
    FaqSection,
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';
</style>
